"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconLocationFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M3 5.801C3 3.08451 5.41572 1 8 1C10.5849 1 13 3.08459 13 5.801C13 7.10743 12.4657 8.44071 11.7311 9.81208C11.1349 10.925 10.3485 12.1638 9.48097 13.5305L9.48096 13.5305L9.48079 13.5308L9.48041 13.5314C9.27306 13.858 9.06108 14.192 8.84596 14.5333C8.66282 14.8238 8.34342 15 8 15C7.65658 15 7.33718 14.8238 7.15404 14.5333C6.93873 14.1917 6.72657 13.8574 6.51905 13.5305C5.65151 12.1638 4.86511 10.925 4.26895 9.81208C3.53433 8.44071 3 7.10743 3 5.801ZM8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M4 7.75125C4 4.50989 6.89097 2 10 2C13.1097 2 16 4.50996 16 7.75125C16 9.32006 15.3573 10.9412 14.4434 12.647C13.703 14.0292 12.7265 15.5676 11.6426 17.2752L11.6426 17.2753L11.6424 17.2756C11.3825 17.685 11.1164 18.1042 10.846 18.5333C10.6628 18.8238 10.3434 19 10 19C9.65658 19 9.33718 18.8238 9.15404 18.5333C8.8835 18.1041 8.61736 17.6848 8.3574 17.2752L8.35738 17.2752C7.27345 15.5676 6.29696 14.0292 5.55656 12.647C4.64274 10.9412 4 9.32006 4 7.75125ZM10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M5 9.7015C5 5.93526 8.36622 3 12 3C15.6346 3 19 5.93534 19 9.7015C19 11.5327 18.2489 13.4416 17.1558 15.482C16.2712 17.1334 15.1046 18.9714 13.8042 21.02L13.8042 21.02L13.8037 21.0208C13.4915 21.5127 13.1715 22.0167 12.846 22.5333C12.6628 22.8238 12.3434 23 12 23C11.6566 23 11.3372 22.8238 11.154 22.5333C10.8284 22.0167 10.5085 21.5126 10.1962 21.0207L10.1961 21.0205L10.1958 21.02C8.89544 18.9714 7.72882 17.1335 6.84417 15.482C5.75114 13.4416 5 11.5327 5 9.7015ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M6 12.2355C6 7.03576 10.8289 3 16 3C21.1723 3 26 7.03584 26 12.2355C26 14.7759 24.9161 17.4578 23.2854 20.3892C21.9671 22.759 20.2289 25.396 18.2794 28.3538C17.8098 29.0662 17.3279 29.7973 16.8367 30.5477C16.6519 30.8299 16.3373 31 16 31C15.6627 31 15.3481 30.8299 15.1633 30.5477C14.6722 29.7975 14.1905 29.0666 13.721 28.3543L13.7207 28.3538C11.7711 25.396 10.0329 22.759 8.7146 20.3892C7.08391 17.4578 6 14.7759 6 12.2355ZM16 17C18.2091 17 20 15.2091 20 13C20 10.7909 18.2091 9 16 9C13.7909 9 12 10.7909 12 13C12 15.2091 13.7909 17 16 17Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;